module.exports = __webpack_public_path__ + "static/media/Anuvadini.f180ad33.png";